import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { CurrentUserService } from 'app/core/user/current-user.service';
import { of, switchMap } from 'rxjs';

export const NoPendingActionsRequiredGuard: CanActivateFn = () => {
    const router = inject(Router);
    const userService = inject(CurrentUserService);

    return userService.get().pipe(
        switchMap(user => {
            const requiredActions = user?.requiredActions

            // Si hay acciones requeridas, redirigimos
            if (requiredActions?.length) {
                return of(router.parseUrl('/sign-up/complete'));
            }

            return of(true);
        })
    );
};
